import twitterFetcher from 'twitter-fetcher';

export default class TwitterWidget {
  constructor(section) {
    this.$el = $(section.el);
    this._renderTweets = this._renderTweets.bind(this);
    this.initializedClass = 'twitter-initialized';
    return this._validate();
  }

  _validate() {
    this.$tweetContainer = $('[data-twitter-tweets]', this.$el);
    this.username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
    const showRetweets = $('[data-twitter-show-retweets]', this.$el).length;
    const showImages = $('[data-twitter-show-images]', this.$el).length;
    const isInitialized = this.$el.hasClass(this.initializedClass) && this.$tweetContainer.length;

    return this._getTweets(showRetweets, showImages, isInitialized);
  }

  _getTweets(showRetweets, showImages, isInitialized) {
    if (!this.username.length) { return this._hasError(false); }
    if (isInitialized) { return; }

    const config = {
      profile: { screenName: this.username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: showRetweets,
      showImages,
      showReplies: true,
      showInteraction: true,
      customCallback: this._renderTweets,
      showInteraction: false,
      useEmoji: true,
    };

    return twitterFetcher.fetch(config);
  }

  _renderTweets(tweets) {
    if (tweets.length) {
      $('[data-tweet]', this.$tweetContainer).empty();

      for (let i = 0; i < tweets.length; i++) {
        const tweet = $(tweets[i]);
        $('[data-tweet]', this.$tweetContainer).append(tweet);
      }

      const media = $('.media', this.$el);
      const user = $('.user', this.$el);
      $('[data-tweet]', this.$tweetContainer).prepend(media);
      $('[data-tweet]', this.$tweetContainer).prepend(user);
      if (`${this.username.toLowerCase()}` !== $('[data-scribe="element:screen_name"]', this.$el).text().toLowerCase()) {
        $('[data-scribe="component:author"] > [data-scribe="element:user_link"]').prepend('\
          <svg class="retweet-svg" viewBox="0 0 32 32"> \
          <path class="path1" d="M4 10h20v6l8-8-8-8v6h-24v12h4zM28 22h-20v-6l-8 8 8 8v-6h24v-12h-4z"></path> \
          </svg>');
      }
      const timestamp = $('.timePosted', this.$el).text().split(' ');
      return $('.timePosted', this.$el).prepend("<span class='twitter-icon'>&#xF12E;</span>");
    }
    return console.log('No tweets to display. Most probable cause is an incorrectly entered Widget ID.');
  }

  _hasError(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.$tweetContainer.html();

    if (response) { return console.log(`Twitter error: ${response.meta.error_message}`); }
  }

  update($el) {
    // Resets the @$el for the current closure
    this.$el = $el;
    return this._validate();
  }
}
